import React from 'react';
import type { CustodyCase } from '../../types/case';
import type { AppConfig } from '../../types/config';
import { DocHeader, KV } from './DocHeader';
import { QrCode } from '../shared/QrCode';
import { PAYMENT_LABEL, categoryLabel } from '../../utils/caseStatus';
import { fmtDateTime, taka } from '../../utils/bn';
export function PaymentReceipt({
  c,
  config
}: {
  c: CustodyCase;
  config: AppConfig;
}) {
  const online = c.payment.source === 'online';
  return <div className="print-area bg-white text-ink mx-auto max-w-[560px] p-6 border border-line" data-id="element-258" data-mp="w5urmdlun5m5">
      <DocHeader office={c.division} title="জরিমানা পরিশোধের রসিদ" data-id="element-259" data-mp="r7b0zzwb95ng" />
      <div className={`mb-3 rounded-md px-3 py-2 text-xs font-semibold ${online ? 'bg-sky text-navy' : 'bg-bdgreen-50 text-bdgreen-700'}`} data-id="element-260" data-mp="1546d617uzd7q">
        {online ? 'অনলাইনে পরিশোধিত — সিমুলেটেড গেটওয়ে নিশ্চিতকরণ (কোনো প্রকৃত পেমেন্ট প্রোভাইডার সংযুক্ত নয়)' : 'অনুমোদিত ডিএমপি কর্মকর্তা কর্তৃক অফিসে গৃহীত ও লিপিবদ্ধ'}
      </div>
      <KV k="PCR নম্বর" v={c.pcr} mono data-id="element-261" data-mp="32wu6924fsbm9" />
      <KV k="যানবাহন" v={`${c.regNo} (${categoryLabel(c.category, config)})`} data-id="element-262" data-mp="1kvcbfsv8oy8p" />
      <KV k="পরিশোধকারী" v={c.ownerName} data-id="element-263" data-mp="1pte517qakfyf" />
      <KV k="নির্ধারিত জরিমানা" v={taka(c.fine)} data-id="element-264" data-mp="1pufifius5ejb" />
      <KV k="অনুমোদিত অতিরিক্ত চার্জ" v={taka(c.extraCharge)} data-id="element-265" data-mp="1usqodihyf4w9" />
      <KV k="সর্বমোট" v={taka(c.fine + c.extraCharge)} data-id="element-266" data-mp="1urfp9vzgelbh" />
      <KV k="পেমেন্ট মাধ্যম" v={c.payment.channel ?? '—'} data-id="element-267" data-mp="1zjqmgr2t7t0c" />
      {online ? <KV k="Transaction ID" v={c.payment.txnId ?? '—'} mono data-id="element-268" data-mp="24ik3gthb2259" /> : <KV k="চালান / রসিদ নং" v={c.payment.challan ?? '—'} mono data-id="element-269" data-mp="24i0it509sznj" />}
      <KV k="পরিশোধের সময়" v={fmtDateTime(c.payment.paidAt)} data-id="element-270" data-mp="28jdqlkmxbcx3" />
      <KV k="অবস্থা" v={PAYMENT_LABEL[c.paymentStatus].label} data-id="element-271" data-mp="28lzxrj5wjqes" />
      {c.payment.officer && <KV k="গ্রহণকারী কর্মকর্তা" v={c.payment.officer} data-id="element-272" data-mp="2dh5gk940coyn" />}
      <div className="mt-4 flex items-end justify-between" data-id="element-273" data-mp="2ih9y82gnjpqg">
        <p className="text-[11px] text-ink-muted max-w-[300px]" data-id="element-274" data-mp="j578wblck14v">স্ক্রিনশট বা অযাচাইকৃত দাবি পেমেন্ট হিসেবে গণ্য নয়। সিস্টেমে নিশ্চিত লেনদেনই বৈধ।</p>
        <QrCode value={`PAY-${c.pcr}-${c.payment.txnId ?? c.payment.challan ?? ''}`} size={84} data-id="element-275" data-mp="o53ci9q4tqjw" />
      </div>
      <p className="mt-2 text-center text-[10px] text-ink-soft" data-id="element-276" data-mp="g44c34akm5vi">প্রোটোটাইপ — নমুনা অর্থের পরিমাণ</p>
    </div>;
}